const getIsRelativeUrl = url => {
  if (!url) return false;
  return url.startsWith('/') && !url.startsWith('//');
};
export { getIsRelativeUrl };
//# sourceMappingURL=getIsRelativeUrl.js.map
